import { useQuery } from "@tanstack/react-query";
import { ApiError } from "../api/client";
import { fetchClockSkewAudit, type ClockSkewRow } from "../api/admin";

/**
 * D-128 — PM web Clock skew audit hook.
 *
 * staleTime: 30s + refetchInterval: 5min — clock skew is a slow-moving signal
 * (workers don't acquire/lose chronic skew on a minute timescale); the 5-min
 * cadence is a reasonable balance between freshness + server load.
 */
export const CLOCK_SKEW_KEY = ["clock-skew"] as const;

export function useClockSkewAudit(days = 7) {
  return useQuery<ClockSkewRow[], ApiError>({
    queryKey: [...CLOCK_SKEW_KEY, days],
    queryFn: () => fetchClockSkewAudit(days),
    staleTime: 30_000,
    refetchInterval: 5 * 60_000,
    refetchOnWindowFocus: false,
  });
}
